import {EChannelType, TChannelType} from 'src/constants';
import {PRIVATE_ROUTES} from 'src/containers/App/routes';
import {EPermission, useGetCurrentUserQuery} from 'src/containers/User';
import PATHS from 'src/paths';

export const createHash: Record<TChannelType, string> = {
  WHATSAPP: PATHS.CHANNELS_WHATSAPP_NEW,
  SMS: PATHS.CHANNELS_SMS_NEW,
  VIBER: PATHS.CHANNELS_VIBER_NEW,
  VK_NOTIFY: PATHS.CHANNELS_VK_NOTIFY_NEW,
  OK_NOTIFY: PATHS.CHANNELS_OK_NOTIFY_NEW,
  PUSH: PATHS.CHANNELS_PUSH_NEW,
  MAX_BOT: PATHS.CHANNELS_MAX_BOT_NEW,
  MAX: PATHS.CHANNELS_MAX_NEW,
  TELEGRAM: PATHS.CHANNELS_TELEGRAM_NEW,
};

export const createTechPartnerHash = {
  WHATSAPP: PATHS.CHANNELS_WHATSAPP_TECH_PARTNER_NEW,
  MAX: PATHS.CHANNELS_MAX_TECH_PARTNER_NEW,
  TELEGRAM: PATHS.CHANNELS_TELEGRAM_TECH_PARTNER_NEW,
} as Record<TChannelType, string>;

type TChannelHash = Partial<Record<TChannelType, string>>;

const getAllowedChannelTypes = (
  userPermissions: EPermission[] = [],
  hash: TChannelHash = {} as TChannelHash,
  excluded: TChannelType[] = [],
) => {
  const types: TChannelType[] = [];

  Object.entries(hash).forEach(([type, path]) => {
    if (excluded.includes(type as EChannelType)) {
      return;
    }

    const {permissions} = PRIVATE_ROUTES[path];

    if (permissions(userPermissions)) {
      types.push(type as TChannelType);
    }
  });

  return types;
};

export const useAllowedChannelTypes = ({
  createHash: hash = createHash,
  skip,
  excludedChannels,
}: {
  createHash?: Partial<Record<TChannelType, string>>;
  skip?: boolean;
  excludedChannels?: TChannelType[];
} | void = {}) => {
  const {data: user} = useGetCurrentUserQuery(undefined, {skip});

  return getAllowedChannelTypes(user?.permissions, hash, excludedChannels) as EChannelType[];
};
